import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import {
  fetchSubdivisions,
  createSubdivision,
  updateSubdivision,
  deleteSubdivision,
  fetchSubdivisionById,
  fetchSubdivisionsByHomeType,
  fetchSubdivisionCounts,
} from "../api/subdivisionApi";

export const useSubdivision = () => {
  const queryClient = useQueryClient();

  const {
    data: subdivisions,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["subdivisions"],
    queryFn: fetchSubdivisions,
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Failed to fetch subdivisions"
      );
    },
  });

  const createSubdivisionMutation = useMutation({
    mutationFn: createSubdivision,
    onSuccess: (data) => {
      toast.success(data.message || "Subdivision created successfully!");
      queryClient.invalidateQueries(["subdivisions"]);
    },
    onError: (error) => {
      console.log("Create subdivision error:", error.response?.data);
      toast.error(
        error.response?.data.message || "Failed to create subdivision!"
      );
    },
  });

  const updateSubdivisionMutation = useMutation({
    mutationFn: updateSubdivision,
    onSuccess: (data) => {
      toast.success(data.message || "Subdivision updated successfully!");
      queryClient.invalidateQueries(["subdivisions"]);
    },
    onError: (error) => {
      console.log("Update subdivision error:", error);
      toast.error(
        error.response?.data.message || "Failed to update subdivision!"
      );
    },
  });

  const deleteSubdivisionMutation = useMutation({
    mutationFn: deleteSubdivision,
    onSuccess: (data) => {
      toast.success(data.message || "Subdivision deleted successfully!");
      queryClient.invalidateQueries(["subdivisions"]);
    },
    onError: (error) => {
      console.log("Delete subdivision error:", error.response?.data);
      toast.error(
        error.response?.data.message || "Failed to delete subdivision!"
      );
    },
  });

  return {
    subdivisions,
    isLoading,
    error,
    createSubdivision: createSubdivisionMutation.mutate,
    createSubdivisionLoading: createSubdivisionMutation.isPending,
    createSubdivisionSuccess: createSubdivisionMutation.isSuccess,
    updateSubdivision: updateSubdivisionMutation.mutate,
    updateSubdivisionLoading: updateSubdivisionMutation.isPending,
    updateSubdivisionSuccess: updateSubdivisionMutation.isSuccess,
    deleteSubdivision: deleteSubdivisionMutation.mutate,
    deleteSubdivisionLoading: deleteSubdivisionMutation.isPending,
    deleteSubdivisionSuccess: deleteSubdivisionMutation.isSuccess,
  };
};
